import { Flex, Text, Box } from "rebass/styled-components";
import Icon from "./Icon";
import Button from "./Button";

export interface OptionsTileProps {
  icon: string;
  title: string;
  btnText: string;
  btnAction: () => void;
}

interface Props {
  title: string;
  items: OptionsTileProps[];
}

const OptionTile = ({ item }: { item: OptionsTileProps }) => {
  const { icon, title, btnText, btnAction } = item;

  return (
    <Flex variant="optionsGrid.tile">
      <Icon name={icon} color="samoyedWhite" width={"80px"} height={"80px"} />
      <Text as="h3" text="h3" variant="optionsGrid.tileText">
        {title}
      </Text>
      <Button variant="optionsGrid.tileButton" onClick={btnAction}>
        {btnText}
      </Button>
    </Flex>
  );
};

function OptionsGrid({ title, items }: Props) {
  return (
    <Box variant="optionsGrid.mainBox">
      <Text as="h2" text="h2" variant="optionsGrid.title">
        {title}
      </Text>
      <Flex variant="optionsGrid.gridFlex">
        {items.map(item => (
          <OptionTile item={item} />
        ))}
      </Flex>
    </Box>
  );
}

export default OptionsGrid;
